import { useQuery } from '@tanstack/react-query';

import { listRegionChannelSettings } from '~/services/PromoService';

import { regionChannelSettingQueryKeys } from './regionChannelSettingQueryKeys';

type Params = {
  query: Parameters<typeof listRegionChannelSettings>[0];
  enabled?: boolean;
};

export function useListRegionChannelSettings({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: regionChannelSettingQueryKeys.list(query),
    queryFn: async ({ signal }) => listRegionChannelSettings(query, { signal }),
    enabled,
  });
}
